<div class="d-flex" aria-label="Actions">
    <button #trashIcon type="button" class="icon-btn fill-iconDefault deleteButton" [ngbPopover]="deleteModal" 
        popoverClass="cxoneConfirmDashboardDeletePopover" triggers="click" container="body" placement="bottom-right top-right" 
        *ngIf="hasWriteAccess && config.isCxOne">
        <svg class="icon-20" [ngbPopover]="deleteTooltip"
        triggers="mouseenter:mouseleave click" popoverClass="cxoneDeletePopover" container="body" placement="bottom-right top-right"
        [attr.aria-label]="deleteTooltip">
            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
        </svg>

        <ng-template #deleteModal let-modal>
            <div>
                <div class="popoverText popoverSpacingTop" style="padding-bottom: 3px;" cvLocalizedText langSection="Dashboards_Landing"
                langKey="Dashboard_Delete_Warning">You are about to delete this dashboard.</div>
                <div class="popoverText popoverSpacingBottom" cvLocalizedText langSection="Dashboards_Landing" langKey="Revert_Warning">
                    This action cannot be undone.</div>
                <div class="confirmBtns">
                    <button type="button" (click)="modal.dismiss()" class="cxone-btn btn-medium btn-popover" style="margin-right: 10px;">
                        <span cvLocalizedText langSection="Dashboards_Landing" langKey="Cancel_Button">Cancel</span>
                    </button>
                    <button type="button" (click)="deleteButtonClick($event)" class="cxone-btn btn-medium btn-primary">
                        <span cvLocalizedText langSection="Dashboards_Landing" langKey="Delete_Button">Delete</span>
                    </button>
                </div>
            </div>
        </ng-template>
    </button>
    <button class="icon-btn fill-disabled deleteButton" [disabled]="!hasWriteAccess" *ngIf="!hasWriteAccess && config.isCxOne">
        <svg class="icon-20">
            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
        </svg>
    </button>
    <button type="button" class="icon-btn fill-iconDefault contextMenuButton" (click)="contextMenuClick($event)"
        aria-label="More actions" cvLocalizedAttrs="aria-label" langSection="Dashboards_Landing" langKey="More_Actions">
        <svg [ngClass]="config.isCxOne ? 'icon-20' : 'icon-12 fill-hover-black'">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
    </button>
</div>
